import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import money, { format } from '../lib/money';
import '../css/refund-summary.css';

class RefundSummary extends Component {

  get organizerRefund() { return money(this.props.organizerRefund); }

  organizerGetsRefund() {
    return !this.organizerRefund.isZero();
  }

  get inviteesRefund() { return money(this.props.inviteesRefund); }

  inviteeGetsRefund() {
    return !this.inviteesRefund.isZero();
  }

  get shouldRender() {
    return this.organizerGetsRefund() || this.inviteeGetsRefund();
  }

  renderOrganizerRefunds() {
    if (!this.organizerGetsRefund()) return null;
    return (
      <div className="organizer-refund col-md-4 col-sm-12">
        <p>
          <FormattedMessage
            id="refundSummary.organizerRefund"
            defaultMessage="You {amount}"
            values={{
              amount: <strong>{format(this.organizerRefund)}</strong>,
            }}
          />
        </p>
      </div>
    );
  }

  renderInviteesRefunds() {
    if (!this.inviteeGetsRefund()) return null;

    return (
      <div className="invitees-refund col-md-4 col-sm-12">
        <p>
          <FormattedMessage
            id="renderSummary.inviteesRefund"
            defaultMessage="{n} {n, plural, one {contributor} other {contributors}} {amount}"
            values={{
              n: this.props.inviteesLength,
              amount: format(this.inviteesRefund),
            }}
          />
        </p>
      </div>
    );
  }

  render() {
    if (!this.shouldRender) return null;

    return (
      <div className="refund-summary">
        <FormattedMessage
          id="refundSummary.title"
          defaultMessage="Refunds"
        />
        <br />
        <span className="cool-grey">
          <FormattedMessage
            id="refundSummary.description"
            defaultMessage="To members who previously paid more than they should based on the current group size {icon}"
            values={{
              icon: <span role="img" aria-label="Cheers">🎉</span>,
            }}
          />
        </span>
        <div className="refund-breakdown row pt-3">
          {this.renderOrganizerRefunds()}
          {this.renderInviteesRefunds()}
        </div>
      </div>
    );
  }
}

RefundSummary.defaultProps = {
  organizerMembership: null,
  inviteesLength: 0,
};

export default RefundSummary;



// WEBPACK FOOTER //
// ./src/desktop/components/refund-summary.js